import angular from 'angular';

angular.module('vrm.components').directive('vrmClickOutside', vrmClickOutside);

/* @ngInject */
function vrmClickOutside() {
    return {
        restrict: 'A',
        link,
    };
}

function checkNesting(element, targetParent) {
    let current = element;
    while (current && current !== document.body) {
        if (current === targetParent) {
            return true;
        }
        current = current.parentElement;
    }
    return false;
}

function link(scope, element, attrs) {
    const callback = attrs.vrmClickOutside;
    const main = element[0];
    const handler = (event) => {
        const isInside = checkNesting(event.target, main);
        if (!isInside) {
            const cancel = scope.$eval(callback, {$event: event});
            if (cancel) {
                event.stopPropagation();
            }
        }
    };
    document.addEventListener('click', handler, { capture: true });
    element.on('$destroy', () => {
        document.removeEventListener('click', handler, { capture: true });
    });
}
